<template>
    <div class="deals-wrapper-item" v-for="index in numberOfBoxes" :key="index">
        <div class="deals-wrapper-dealbox deal-box-wrapper">
            <div class="deal-box-img-container">
                <div class="blur-box shimmer"></div>
            </div>
            <div class="deal-box-desc">
                <div class="shimmer shimmer-text"></div>
                <div class="shimmer shimmer-text"></div>
                <div class="shimmer shimmer-text"></div>
            </div>
            <div v-if="showPrice" class="deal-box-prices">
                <div class="shimmer shimmer-price shimmer-price-crossed"></div>
                <div class="shimmer shimmer-price shimmer-price-deal"></div>
            </div>
            <div v-if="showPrice" class="logo-img-container">
                <div class="shimmer shimmer-logo"></div>
            </div>
        </div>
    </div>
</template>
<script setup lang="ts">
    withDefaults(defineProps<{
        numberOfBoxes?: number
        showPrice?: boolean
    }>(), {
        numberOfBoxes: 16,
        showPrice: true
    })
</script>

<style scoped>
    .deal-box-wrapper {
        height: 100%;
        border: 1px solid #FFCDD0;
        padding: 0;
        display: flex;
        flex-direction: column;
        justify-content: flex-end;
        align-items: center;
    }

    .deal-box-img-container {
        display: flex;
        justify-content: center;
        align-items: center;
        width: 100%;
        min-height: 264px;
        max-height: 264px;
    }

    .blur-box {
        width: 75%;
        max-width: 75%;
        height: 264px;
        max-height: 264px;
    }

    .deal-box-desc {
        width: 90%;
        margin-top: 12px;
        margin-bottom: 12px;
        min-height: 60px;
        display: flex;
        flex-direction: column;
        justify-content: center;
        align-items: center;
    }

    .shimmer-text {
        width: 100%;
        height: 18px;
        margin-bottom: 6px;
    }

    .shimmer-text:last-child {
        width: 70%;
        margin-bottom: 0;
    }

    .deal-box-prices {
        display: flex;
        flex-direction: column;
        align-items: center;
        width: 100%;
        margin-bottom: 5px;
    }

    .shimmer-price {
        margin-bottom: 4px;
    }

    .shimmer-price-crossed {
        width: 60px;
        height: 16px;
    }

    .shimmer-price-deal {
        width: 80px;
        height: 28px;
    }

    .logo-img-container {
        width: 100%;
        display: flex;
        justify-content: center;
        align-items: center;
        margin-top: 8px;
    }

    .shimmer-logo {
        width: 95px;
        height: 28.64px;
    }

    .shimmer {
        animation-duration: 1s;
        animation-fill-mode: forwards;
        animation-iteration-count: infinite;
        animation-name: placeHolderShimmer;
        animation-timing-function: linear;
        background: #f6f7f9;
        background-image: linear-gradient(to right, #f6f7f9 0%, #e9ebee 20%, #f6f7f9 40%, #f6f7f9 100%);
        background-repeat: no-repeat;
        background-size: 800px 104px;
        border-radius: 4px;
    }

    @keyframes placeHolderShimmer {
        0% {
            background-position: -468px 0;
        }
        100% {
            background-position: 468px 0;
        }
    }

    @media all and (max-width: 980px) {
        .blur-box {
            max-width: 80%;
        }

        .logo-img-container {
            display: none;
        }
    }
</style>

